module.exports = __webpack_public_path__ + "img/bt.d35b5dd2.svg";